import { useSyncExternalStore } from 'react'

const NARROW_QUERY = '(max-width: 480px)'
const MEDIUM_QUERY = '(max-width: 768px)'

const hasMatchMedia = (): boolean => typeof window.matchMedia === 'function'

const subscribe = (onChange: () => void): (() => void) => {
  if (!hasMatchMedia()) {
    return () => {}
  }
  const narrow = window.matchMedia(NARROW_QUERY)
  const medium = window.matchMedia(MEDIUM_QUERY)
  narrow.addEventListener('change', onChange)
  medium.addEventListener('change', onChange)
  return () => {
    narrow.removeEventListener('change', onChange)
    medium.removeEventListener('change', onChange)
  }
}

const getSnapshot = (): 1 | 2 | 3 => {
  if (!hasMatchMedia()) {
    return 3
  }
  if (window.matchMedia(NARROW_QUERY).matches) {
    return 1
  }
  if (window.matchMedia(MEDIUM_QUERY).matches) {
    return 2
  }
  return 3
}

export const useTileColumns = (): 1 | 2 | 3 => useSyncExternalStore(subscribe, getSnapshot)
